import PropTypes from 'prop-types';
import globalValues from '../../static-data/global-values.json';

export default function ArticleAffiliate(props) {
	const { article } = props;

	const { affiliateCopy } = globalValues.data.themeSettings.postSettings;

	return (
		affiliateCopy && article.additionalDetails?.affiliateCopyToggle
			? (
				<div className="article-affiliate">
					<p className="article-affiliate-copy">
						{affiliateCopy}
					</p>
				</div>
			)
			: null
	);
}

ArticleAffiliate.propTypes = {
	article: PropTypes.object.isRequired,
};
